import React, { createContext, useContext } from 'react'
import { compose, withProps } from 'recompose'
import { connect } from 'react-redux'
import { IntlProvider, injectIntl } from 'react-intl'
import LOCALES from 'src/locales'

export const CustomIntlContext = createContext()

export const CustomIntlProvider = ({ children, ...restProps }) => (
  <IntlProvider {...restProps}>
    <InjectWrap children={children} />
  </IntlProvider>
)

const InjectWrap = injectIntl(({ intl, children }) => (
  <CustomIntlContext.Provider value={intl}>
    {children}
  </CustomIntlContext.Provider>
))

export const useFormatMessage = () => {
  const intl = useContext(CustomIntlContext)
  return intl.formatMessage
}

export default compose(
  connect(({ locale }) => ({
    locale: locale.locale
  })),
  withProps(({ locale }) => ({
    key: locale,
    messages: LOCALES[locale.slice(0, 2)]
  }))
)(CustomIntlProvider)
